import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { forwardRef } from "react";
import { Box } from "./auth-service-tools244.js";
import { useScrollAreaContext } from "./auth-service-tools543.js";
import { useMergedRef } from "./auth-service-tools278.js";
const ScrollAreaViewport = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    style,
    ...others
  } = _ref;
  const ctx = useScrollAreaContext();
  const rootRef = useMergedRef(ref, ctx.onViewportChange);
  return /* @__PURE__ */jsxRuntimeExports.jsx(Box, { ...others,
    ref: rootRef,
    style: {
      overflowX: ctx.scrollbarXEnabled ? "scroll" : "hidden",
      overflowY: ctx.scrollbarYEnabled ? "scroll" : "hidden",
      ...style
    },
    children: /* @__PURE__ */jsxRuntimeExports.jsx("div", {
      style: {
        minWidth: "100%",
        display: "table"
      },
      ref: ctx.onContentChange,
      children
    })
  });
});
ScrollAreaViewport.displayName = "@mantine/core/ScrollAreaViewport";
export { ScrollAreaViewport };